(() => {
  let lockCount = 0;
  let savedScrollY = 0;

  const lock = () => {
    if (lockCount === 0) {
      savedScrollY = window.scrollY;
      const { body } = document;
      body.style.position = 'fixed';
      body.style.top = `-${savedScrollY}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
    }
    lockCount += 1;
  };

  const unlock = () => {
    if (lockCount === 0) return;
    lockCount -= 1;
    if (lockCount === 0) {
      const { body } = document;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      window.scrollTo(0, savedScrollY);
    }
  };

  const lockScroll = () => {
    const body = document.querySelector('body');
    body.style.overflow = 'hidden';
  };

  const unlockScroll = () => {
    const body = document.querySelector('body');
    body.style.overflow = 'auto';
  };

  window.cbScrollLock = { lock, unlock, lockScroll, unlockScroll };
})();
